import { memo, RefObject } from 'react';
import { IconArrowRightBold, Text } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { CompareItemImage, CompareItemWrapper, MySizeText, TableDataCell, TableRow } from './styles';

interface MySizeRowProps {
  label: string;
  onAction?: () => void;
  values?: string[];
  fixedColumnWidth: string;
  columnMinWidth?: string;
  colSpan: number;
  matchedFlags?: boolean[];
  compareRowImage?: string;
  actionCellRef?: RefObject<HTMLTableCellElement>;
}

export const MySizeRow = memo(
  ({
    label,
    onAction,
    values,
    fixedColumnWidth,
    columnMinWidth = '84px',
    colSpan,
    matchedFlags,
    compareRowImage,
    actionCellRef,
  }: MySizeRowProps) => {
    return (
      <TableRow hasBorder>
        <LabelCell
          width={fixedColumnWidth}
          isSticky
          isRowHeader
          isCompareRow
          onClick={() => {
            if (values && onAction) {
              onAction();
            }
          }}
          style={{ cursor: values && onAction ? 'pointer' : 'default' }}
        >
          <CompareItemWrapper isCompareRow>
            {compareRowImage && <CompareItemImage src={compareRowImage} alt='비교상품' />}
            <MySizeText isCompareRow hasImage={!!compareRowImage} style={{ position: 'relative' }}>
              {label}
              {values && onAction && (
                <IconArrowRightBold width={16} height={16} color='iconStrong' style={{ position: 'absolute' }} />
              )}
            </MySizeText>
          </CompareItemWrapper>
        </LabelCell>

        {values ? (
          values.map((value, index) => {
            const isValueValid = value && value !== '-' && value !== '0';
            // 비교상품 row: 유효한 값은 textPrimary, 유효하지 않은 값은 textSecondary
            const textColor = isValueValid ? 'textPrimary' : 'textSecondary';

            return (
              <ValueCell key={index} width={columnMinWidth} isCompareRow>
                <Text variant='Body_13_Medium' color={textColor}>
                  {value}
                </Text>
              </ValueCell>
            );
          })
        ) : (
          <ActionCell ref={actionCellRef} width='auto' colSpan={colSpan} isCompareRow />
        )}
      </TableRow>
    );
  },
);

const LabelCell = styled(TableDataCell)`
  z-index: 2;
  background-color: ${vars.color.backgroundOnElevated};
`;

const ValueCell = styled(TableDataCell)`
  background-color: ${vars.color.backgroundOnElevated};
`;

const ActionCell = styled(TableDataCell)`
  background-color: ${vars.color.backgroundOnElevated};
  padding: 12px 0;
`;
